import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  visuallyHidden: {
    position: 'absolute',
    clip: 'rect(0 0 0 0)',
    width: 1,
    height: 1,
    margin: -1,
  },
}));
